import { FC, useContext } from 'react';
import { ThemeProvider } from 'styled-components';
import { AuthContext } from '@greatmindsorg/assess-web-core-lib';
import baseTheme from '@insync-students-themes/baseTheme';
import { StyledAssignmentContainer } from './Assignment.styled';
import { HomeContext } from '../../Context/HomeContext';
import dynamic from 'next/dynamic';
import { useAssignment } from './useAssignment';
import { AppProviders } from '@insync-students-lib/hooks/useProviders';
import { Spinner } from '@greatmindsorg/assess-web-core-lib';
import { useTranslation } from 'react-i18next';
const InsyncAssignments = dynamic(() => import('@insync-students-components/pages/Assignments/Assignments.component').then(s => s.InsyncAssignments), {
  ssr: false
});
type AssignmentPageProps = {
  assignmentId: string;
};
function AppAssignmentPage(props: AssignmentPageProps) {
  const authState = useContext(AuthContext);
  return <AppProviders schoolYear={authState.schoolYear?.id}>
      <AssignmentPage {...props} />
    </AppProviders>;
}
const AssignmentPage: FC<AssignmentPageProps> = ({
  assignmentId
}) => {
  const {
    t
  } = useTranslation();
  const homeContextState = useContext(HomeContext);
  const authContextState = useContext(AuthContext);
  const {
    assignment,
    error: assignmentError
  } = useAssignment(assignmentId);
  return <HomeContext.Provider value={homeContextState}>
      <ThemeProvider theme={baseTheme}>
        <StyledAssignmentContainer>
          {assignment?.resourceId ? <InsyncAssignments assignment={assignment} user={authContextState.user} assignmentError={assignmentError} /> : <Spinner className="spinner override-color" ariaLabel={t('common.generalConstants.ariaLabel.fetchingAssignmentsData')} />}
        </StyledAssignmentContainer>
      </ThemeProvider>
    </HomeContext.Provider>;
};
export default AppAssignmentPage;